export default __webpack_public_path__ + "static/media/IMG_9744.9eaaa39f.jpeg";